/* unplugin-vue-components disabled */import script from "./BlackDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BlackDialog.vue?vue&type=script&setup=true&lang=js"

import "./BlackDialog.vue?vue&type=style&index=0&id=33b4a9cc&lang=stylus"

const __exports__ = script;

export default __exports__